import React from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import { getStorage } from "../services/storageService";
import { ErrorMessage } from "../components";

interface ProtectedRouteProps {
  isAuthorized: boolean;
  isPublic: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  isAuthorized,
  isPublic,
}) => {
  const location = useLocation();
  
  // Check if client_id exists in localStorage
  const clientId = getStorage('client_id');
  const hasValidClientId = clientId && clientId !== 'null' && clientId !== '';
  
  // If at root path and client_id is valid, redirect to settings
  if (location.pathname === '/') {
    return <Navigate to="/settings" replace />;
  }
  
  // If no valid client_id is found and the route is not public, show ErrorMessage
  if (!hasValidClientId && !isPublic) {
    return (
      <ErrorMessage 
        message="Client ID is missing or invalid."
        suggestion="Please access this application with a valid client_id parameter in the URL."
      />
    );
  }
  
  return <Outlet />;
};

export default ProtectedRoute;
